import { Component } from '@angular/core';
import { EmailJsService } from '../services/emailjs.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-newsletter-signup',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './newsletter-signup.component.html',
  styleUrls: ['./newsletter-signup.component.css']
})
export class NewsletterSignupComponent {
  formData = { name: '', email: '', message: '' };
  isSubmitting = false;
  successMessage = '';
  errorMessage = '';

  constructor(private emailJsService: EmailJsService) {}

  async onSubmit() {
    if (!this.formData.name || !this.formData.email) {
      this.errorMessage = 'Please fill out all fields.';
      this.successMessage = '';
      return;
    }

    this.isSubmitting = true;
    this.errorMessage = '';
    this.successMessage = '';

    // Set the message for the email
    this.formData.message = `This user wants to join the email list: ${this.formData.email}`;

    try {
      const result = await this.emailJsService.sendEmail(this.formData, 'NewsletterSignup');
      if (result.status === 200) {
        this.successMessage = 'Thank you for signing up! You’ll receive our press release updates soon.';
        this.formData = { name: '', email: '', message: '' }; // Reset form
      } else {
        this.errorMessage = 'Failed to sign up. Please try again later.';
      }
    } catch (error) {
      console.error('Signup error:', error);
      this.errorMessage = 'An error occurred. Please try again later.';
    } finally {
      this.isSubmitting = false;
    }
  }
}
